import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";

export const MegaPanel = ({ onClose }) => {
  const { groups } = useSite();
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      className="absolute inset-x-0 top-full flex justify-center px-4 pointer-events-none"
    >
      <div className="pointer-events-auto w-full max-w-[1280px] bg-white border-t-[3px] border-brand rounded-b-2xl shadow-2xl" data-testid="mega-menu-panel">
        <div className="max-h-[72vh] overflow-y-auto thin-scroll">
        <div className="px-10 py-8 columns-5 gap-8">
          {groups.filter((g) => g.schools.length).map((g) => (
            <div key={g.id} className="break-inside-avoid mb-6" data-testid={`mega-group-${g.id}`}>
              <h4 className="text-[13px] font-bold uppercase tracking-wider text-brand mb-2" style={{ fontFamily: "Arial, sans-serif" }}>{g.name}</h4>
              <ul className="space-y-1.5">
                {g.schools.map((s) => (
                  <li key={s.id}>
                    <Link to={`/school/${s.slug}`} onClick={onClose} className="block text-[13px] leading-snug text-charcoal/80 hover:text-brand transition-colors duration-200" data-testid={`mega-school-${s.slug}`}>
                      {s.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        </div>
      </div>
    </motion.div>
  );
};
